export enum ComposeSnapshotChangeType {
  PUT = 'PUT',
  DELETE = 'DELETE',
}
